import { render, staticRenderFns } from "./billboard.vue?vue&type=template&id=fcd8b006"
import script from "./billboard.vue?vue&type=script&lang=js"
export * from "./billboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports